import { render, staticRenderFns } from "./AddContactModal.vue?vue&type=template&id=4a0d951f&"
import script from "./AddContactModal.vue?vue&type=script&lang=js&"
export * from "./AddContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports